import { Identifier } from "../../core";
export class ProductTypeId extends Identifier {
    constructor(id) {
        super("ProductTypeId", id);
    }
}
